import { useState } from "react";

function UsersManager({ users, onCreateUser, onToggleUserStatus, onChangeUserPassword, onChangeUserRol, onDeleteUser }) {
  const [form, setForm] = useState({ username: "", password: "", rol: "operador" });
  const [passwordDrafts, setPasswordDrafts] = useState({});

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreate = async (event) => {
    event.preventDefault();
    await onCreateUser(form);
    setForm({ username: "", password: "", rol: "operador" });
  };

  return (
    <article className="panel">
      <div className="section-title">
        <h2>Gestión de usuarios</h2>
        <span>{users.length} elementos</span>
      </div>

      <form className="form-grid" onSubmit={handleCreate}>
        <label>
          <span className="visually-hidden">Usuario nuevo</span>
          <input
            name="username"
            value={form.username}
            onChange={handleFormChange}
            placeholder="Usuario nuevo"
            aria-label="Usuario nuevo"
            required
          />
        </label>
        <label>
          <span className="visually-hidden">Contraseña inicial</span>
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleFormChange}
            placeholder="Contraseña inicial"
            aria-label="Contraseña inicial"
            required
          />
        </label>
        <label>
          <span className="visually-hidden">Rol</span>
          <select name="rol" value={form.rol} onChange={handleFormChange} aria-label="Rol">
            <option value="operador">Operador</option>
            <option value="admin">Admin</option>
          </select>
        </label>
        <button type="submit">Crear usuario</button>
      </form>

      <div className="list-stack" style={{ marginTop: 12 }}>
        {users.map((user) => (
          <div key={user.id} className="list-item">
            <strong>{user.username}</strong>
            <span className={user.activo ? "status-ok" : "status-danger"}>{user.activo ? "Activo" : "Inactivo"}</span>

            <div className="inline-actions">
              <select
                value={user.rol}
                aria-label={`Rol de ${user.username}`}
                onChange={(event) => onChangeUserRol(user.id, event.target.value)}
              >
                <option value="operador">Operador</option>
                <option value="admin">Admin</option>
              </select>
              <button
                type="button"
                className="secondary-button"
                onClick={() => onToggleUserStatus(user.id, !user.activo)}
              >
                {user.activo ? "Desactivar" : "Activar"}
              </button>
              <button
                type="button"
                className="secondary-button danger"
                onClick={() => {
                  if (window.confirm(`¿Eliminar usuario "${user.username}"? Esta acción no se puede deshacer.`)) {
                    onDeleteUser(user.id);
                  }
                }}
              >
                Eliminar
              </button>
            </div>

            <div className="inline-actions">
              <input
                className="inline-input"
                type="password"
                placeholder="Nueva contraseña"
                aria-label={`Nueva contraseña de ${user.username}`}
                value={passwordDrafts[user.id] || ""}
                onChange={(event) =>
                  setPasswordDrafts((prev) => ({
                    ...prev,
                    [user.id]: event.target.value,
                  }))
                }
              />
              <button
                type="button"
                className="secondary-button"
                onClick={async () => {
                  const password = (passwordDrafts[user.id] || "").trim();
                  if (!password) {
                    return;
                  }
                  await onChangeUserPassword(user.id, password);
                  setPasswordDrafts((prev) => ({
                    ...prev,
                    [user.id]: "",
                  }));
                }}
              >
                Cambiar contraseña
              </button>
            </div>
          </div>
        ))}
      </div>
    </article>
  );
}

export default UsersManager;
